import { SVG } from '../SVG'

const TrashCanIcon = ({ style = {}, ...props }) => (
  <SVG
    width='33'
    height='33'
    viewBox='0 0 33 33'
    fill='none'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    xmlns='http://www.w3.org/2000/svg'
    style={{ stroke: 'var(--primary-color)', ...style }}
    {...props}
  >
    <path d='M27.9224 7.5H5.92236' />
    <path d='M13.9224 13.5V21.5' />
    <path d='M19.9224 13.5V21.5' />
    <path d='M25.9224 7.5V26.5C25.9224 26.7652 25.817 27.0196 25.6295 27.2071C25.4419 27.3946 25.1876 27.5 24.9224 27.5H8.92236C8.65715 27.5 8.40279 27.3946 8.21526 27.2071C8.02772 27.0196 7.92236 26.7652 7.92236 26.5V7.5' />
    <path d='M21.9224 7.5V5.5C21.9224 4.96957 21.7116 4.46086 21.3366 4.08579C20.9615 3.71071 20.4528 3.5 19.9224 3.5H13.9224C13.3919 3.5 12.8832 3.71071 12.5082 4.08579C12.1331 4.46086 11.9224 4.96957 11.9224 5.5V7.5' />
  </SVG>
)

export default TrashCanIcon
